"use strict";

import { Collection } from "Collection";
import { FormDecorationElementsModel } from 'Models/FormDecorationElementsModel';
import { Objects } from "Constants/objects";
export var FormDecorationElementsCollection = Collection.extend({
  model: FormDecorationElementsModel,
  object: Objects.SysFormDecorationElements
});